exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".complete-change{min-height:calc(100vh - 191px);padding:5rem 0;display:flex;flex-direction:column;align-items:center}.complete-change__title{height:37px;font-family:NanumBarunGothicOTF;font-size:32px;text-align:center}.pass-complete{width:460px;height:297px;object-fit:contain;opacity:.97;margin:20px 0}.complete-change-description1{height:32px;font-family:NanumBarunGothicOTF;font-size:28px;text-align:center;color:#000}.complete-change-description2{height:23px;font-family:NanumBarunGothicUltraLightOTF;font-size:20px;text-align:center;color:#c2c2c2}.completeChangeBtn{width:416px;height:64px;border-radius:3px;box-shadow:0 3px 10px 0 rgba(75,116,255,.6);background-color:#4b74ff;font-family:NanumBarunGothicOTF;font-size:20px;text-align:center;color:#fff;border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e6e86732","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LoginManager/Find/CompleteChange.vue
// module id = 149
// module chunks = 0